import { render, staticRenderFns } from "./Sales_Filter.vue?vue&type=template&id=2c0587f1&scoped=true&"
import script from "./Sales_Filter.vue?vue&type=script&lang=js&"
export * from "./Sales_Filter.vue?vue&type=script&lang=js&"
import style0 from "./Sales_Filter.vue?vue&type=style&index=0&id=2c0587f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0587f1",
  null
  
)

export default component.exports